import MainLayout from "./MainLayout";
import styles from "../assets/styles/ContactPage.module.css";
import "../assets/styles/styles.css";
import { Helmet } from "react-helmet";
import { useState } from "react";

export default function Contact() {
    const email = process.env.REACT_APP_EMAIL;
    const phone = process.env.REACT_APP_PHONE;

    return (
        <MainLayout>
            <Helmet>
                <title>Client Portal</title>
            </Helmet>
            <PortalLogin/>
            {/* <div className={styles.container}>
                <div className={`${styles.header} maxMainContainer`}>
                    <div className="maxSubContainer">
                        <h1>Contact</h1>
                        <p>
                            I’m here to assist with any inquiries or projects
                            you may have. Feel free to reach out, and I’ll get
                            back to you within a couple of hours.
                        </p>
                        <a href={`mailto:${email}`}>Send an email</a>
                    </div>
                </div>
                <div className={`${styles.content} maxMainContainer`}>
                    <div className={`${styles.subContent} maxSubContainer`}>
                        <div>
                            <i className="fa-solid fa-message"></i>
                            <h3>Get in touch</h3>
                            <p>Work and general inquiries</p>
                            <a href={`mailto:${email}`}>{email}</a>
                            <a href={`tel:${phone}`}>{phone}</a>
                        </div>
                        <div>
                            <i className="fa-regular fa-clock"></i>
                            <h3>Availability hours</h3>
                            <p>Monday – Friday</p>
                            <p>9 am to 5 pm GMT+2</p>
                        </div>
                    </div>
                </div>
            </div> */}
        </MainLayout>
    );
}
const PortalLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh", // full screen
      padding: "20px",
      backgroundColor: "#ffffffff",
      gap: "24px",
    },
    header: {
      fontSize: "2rem",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "20px",
    },
    input: {
      width: "320px", // consistent width
      padding: "14px 20px",
      borderRadius: "999px", // capsule shape
      border: "1.5px solid #ccc",
      fontSize: "1rem",
      outline: "none",
    },
    error: {
      color: "#d63384",
      fontSize: "0.875rem",
      marginTop: "4px",
      textAlign: "left",
      paddingLeft: "14px",
    },
    btn: {
      width: "320px", // match inputs
      padding: "14px 0",
      fontSize: "1rem",
      fontWeight: "600",
      borderRadius: "999px", // capsule shape
      backgroundColor: "#2b213b",
      color: "#fff",
      cursor: "pointer",
      border: "none",
      transition: "transform 0.3s ease, background-color 0.3s ease",
    },
    btnDisabled: {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    popupOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    },
    popup: {
      backgroundColor: "#fff",
      borderRadius: "16px",
      padding: "24px 32px",
      maxWidth: "400px",
      textAlign: "center",
      position: "relative",
    },
    closeBtn: {
      position: "absolute",
      top: "12px",
      right: "12px",
      border: "none",
      background: "transparent",
      fontSize: "1.25rem",
      cursor: "pointer",
    },
  };

  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "Email is invalid";

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6) newErrors.password = "Password must be at least 6 characters";
    else if (password.length > 20) newErrors.password = "Password must be at most 20 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = () => {
    if (validate()) setShowPopup(true);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Client Portal Login</h2>
      <p style={{ maxWidth: "400px", textAlign: "center", color: "#555", marginBottom: "24px" }}>
  Access the portal using credentials provided by the developer. View the progress of your project anytime without the need for daily meetings.
</p>


      {/* Email Field */}
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        {errors.email && <span style={styles.error}>{errors.email}</span>}
      </div>

      {/* Password Field */}
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />
        {errors.password && <span style={styles.error}>{errors.password}</span>}
      </div>

      {/* Login Button */}
      <button
        onClick={handleLogin}
        style={{
          ...styles.btn,
          ...(email && password ? {} : styles.btnDisabled),
        }}
        disabled={!email || !password}
      >
        Login
      </button>

      {/* Popup */}
      {showPopup && (
        <div style={styles.popupOverlay}>
          <div style={styles.popup}>
            <button style={styles.closeBtn} onClick={() => setShowPopup(false)}>
              ×
            </button>
            <h3>Portal Under Construction</h3>
            <p>This portal is still in development.</p>
          </div>
        </div>
      )}
    </div>
  );
};